import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/ar.svg'
import _imports_2 from '@/assets/img/us.svg'


const _hoisted_1 = { class: "min-h-screen flex flex-col justify-between" }
const _hoisted_2 = { class: "flex flex-col flex-1 items-center justify-center -mt-36" }
const _hoisted_3 = { class: "bg-white rounded-xl shadow-md p-5 w-11/12 md:w-8/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12" }
const _hoisted_4 = { class: "w-full flex flex-col my-4 text-center" }
const _hoisted_5 = { class: "text-xl font-weight-bolder text-gray-800" }
const _hoisted_6 = { class: "text-xl font-weight-bolder text-gray-500" }
const _hoisted_7 = { class: "text-xl font-weight-bolder text-gray-500 mt-3" }
const _hoisted_8 = { class: "text-base font-weight-bolder text-gray-400" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "text-sm text-red-500 p-error" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_15 = { class: "pi pi-check mr-2" }
const _hoisted_16 = { class: "w-full flex flex-col mt-8 text-center" }
const _hoisted_17 = {
  key: 0,
  href: "#",
  class: "text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer"
}
const _hoisted_18 = { class: "flex items-center gap-3 md:gap-4 my-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!
  const _component_RecuperarPasswordView = _resolveComponent("RecuperarPasswordView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex justify-center items-center" }, [
            _createElementVNode("a", {
              class: "text-center",
              href: "/"
            }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "p-2.5 w-24 h-auto"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.configuracionMeeting?.evento?.descripcion), 1),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.configuracionMeeting?.descripcion), 1),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('label.inicio.sesion')), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('label.ingresa.mail.contrasenia')), 1)
          ]),
          _createVNode(_component_Form, {
            onSubmit: _ctx.onSubmit,
            "validation-schema": _ctx.schema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "mail",
                      placeholder: "Mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Field, {
                  name: "password",
                  modelValue: _ctx.formData.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "password",
                      placeholder: "Contraseña",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_15, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(_toDisplayString(_ctx.$t('boton.ingresar')), 1)
              ], 8, _hoisted_13)
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.recuperarPassword && _ctx.recuperarPassword(...args))),
              class: "text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer"
            }, _toDisplayString(_ctx.$t('label.oblvide.password')), 1),
            (_ctx.configuracionMeeting && _ctx.configuracionMeeting?.habilitarRegistro)
              ? (_openBlock(), _createElementBlock("a", _hoisted_17, _toDisplayString(_ctx.$t('label.registrarme')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLanguage('es'))),
            class: "transition hover:scale-125 cursor-pointer"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("img", {
              src: _imports_1,
              class: "h-6 md:h-8"
            }, null, -1)
          ])),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLanguage('en'))),
            class: "transition hover:scale-125 cursor-pointer"
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: _imports_2,
              class: "h-6 md:h-8"
            }, null, -1)
          ]))
        ])
      ])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"]),
    (_ctx.recuperarPasswordVisible)
      ? (_openBlock(), _createBlock(_component_RecuperarPasswordView, {
          key: 0,
          closeFunction: _ctx.cerrarRecuperarPassword
        }, null, 8, ["closeFunction"]))
      : _createCommentVNode("", true)
  ], 64))
}